import { render, staticRenderFns } from "./CalendarsDashboard.vue?vue&type=template&id=b33e794e&scoped=true&"
import script from "./CalendarsDashboard.vue?vue&type=script&lang=js&"
export * from "./CalendarsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CalendarsDashboard.vue?vue&type=style&index=0&id=b33e794e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33e794e",
  null
  
)

export default component.exports